import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const LogoutRedirect = () => {
  const history = useHistory();

  useEffect(() => {
    history.push('/logout');
  }, [history]);

  return null;
};

export default LogoutRedirect;
